import React from 'react';
import classNames from 'classnames';
import { LAYOUT } from '@wix/live-video-commons';
import { useExternalUserId } from '../../../session-provider';
import { useVideoConfig } from '../../../video-config-provider';
import s from './name.scss';
export var Name = function (_a) {
    var _b;
    var attendeeId = _a.attendeeId, focused = _a.focused;
    var _c = useVideoConfig(), getParticipantName = _c.getParticipantName, dashboard = _c.dashboard, _d = _c.knownClients, knownClients = _d === void 0 ? [] : _d, texts = _c.texts, mobile = _c.mobile, sidePanelOpened = _c.sidePanelOpened, layout = _c.layout, recorder = _c.recorder;
    var externalUserId = useExternalUserId(attendeeId);
    var host = knownClients.find(function (_a) {
        var clientId = _a.clientId, isHost = _a.isHost;
        return attendeeId === clientId && isHost;
    });
    var name = getParticipantName(externalUserId) || '';
    if (mobile && (layout === LAYOUT.GRID || !focused)) {
        return null;
    }
    return (React.createElement("div", { className: classNames(s.container, (_b = {},
            _b[s.dashboardContainer] = dashboard,
            _b[s.mobile] = mobile,
            _b[s.sidePanelOpened] = sidePanelOpened,
            _b[s.recorderFonts] = recorder,
            _b)) }, "".concat(name).concat(host ? " ".concat(texts.host) : '')));
};
//# sourceMappingURL=name.js.map